module.exports = __webpack_public_path__ + "static/media/sample_cha_container_updates.04934f0b.csv";